// extracted by mini-css-extract-plugin
module.exports = {"productForm__quickLinks":"styles_productForm__quickLinks__rsBsj"};